import { documentConstants } from "../../constants";
import { documentService } from "../../../services/api.documents";
import { notify } from "reapop";

export const moveActions = {
  getAll,
  getById,
  create,
  update,
  archive,
  delete: _delete,
};

function getAll(params) {
  return (dispatch) => {
    dispatch(request());

    documentService.getAllMoves(params).then(
      (response) => dispatch(success(response)),
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка при получении списка документов на перемещение",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request() {
    return { type: documentConstants.GETALL_REQUEST_MOVE };
  }
  function success(response) {
    return { type: documentConstants.GETALL_SUCCESS_MOVE, response };
  }
  function failure(error) {
    return { type: documentConstants.GETALL_FAILURE_MOVE, error };
  }
}

function getById(id) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.getMoveById(id).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.GETBYID_REQUEST_MOVE, id };
  }
  function success(response) {
    return { type: documentConstants.GETBYID_SUCCESS_MOVE, response };
  }
  function failure(error) {
    return { type: documentConstants.GETBYID_FAILURE_MOVE, error };
  }
}

function create(params) {
  return (dispatch) => {
    dispatch(request(params));

    documentService.createMove(params).then(
      (response) => {
        dispatch(success(response.result));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(response) {
    return { type: documentConstants.CREATE_REQUEST_MOVE, response };
  }
  function success(response) {
    return { type: documentConstants.CREATE_SUCCESS_MOVE, response };
  }
  function failure(error) {
    return { type: documentConstants.CREATE_FAILURE_MOVE, error };
  }
}

function update(id, params) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.updateMove(id, params).then(
      (response) => {
        dispatch(success(response.result));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.UPDATE_REQUEST_MOVE, id };
  }
  function success(response) {
    return { type: documentConstants.UPDATE_SUCCESS_MOVE, response };
  }
  function failure(error) {
    return { type: documentConstants.UPDATE_FAILURE_MOVE, error };
  }
}

function archive(id, type) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.archiveDocument(id, type).then(
      (response) => {
        dispatch(success(id));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.ARCHIVE_REQUEST_MOVE, id };
  }
  function success(id) {
    return { type: documentConstants.ARCHIVE_SUCCESS_MOVE, id };
  }
  function failure(error) {
    return { type: documentConstants.ARCHIVE_FAILURE_MOVE, error };
  }
}

function _delete(id, type){
  return (dispatch) => {
    dispatch(request(id));

    documentService.deleteDocument(id, type).then(
      (response) => {
        dispatch(success(id));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(id, error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    )
  }

  function request(id){
    return {type: documentConstants.DELETE_REQUEST_MOVE, id};
  }
  function success(id){
    return {type: documentConstants.DELETE_SUCCESS_MOVE, id};
  }
  function failure(id){
    return { type: documentConstants.DELETE_FAILURE_MOVE, id, error };
  }
}
